import { Button, Col, Descriptions, Row, Typography } from 'antd';
import styled from 'styled-components';
import { Map, MapMarker } from 'react-kakao-maps-sdk';

import { Project, projectStatusKorean } from '../../modules/projects';
import { styledDescriptions } from '../styled/mixin';
import Title from 'antd/lib/typography/Title';
const { Text } = Typography;

const StyledDiv = styled.div`
  ${styledDescriptions}
`;

interface ProjectOverviewComponentProps {
  project: Project;
  coords: any;
  moveToEditPage: () => void;
}
function ProjectOverviewComponent({
  project,
  coords,
  moveToEditPage,
}: ProjectOverviewComponentProps) {
  return (
    <StyledDiv>
      <Row justify={'space-between'}>
        <Col>
          <Title level={3}>공사현황</Title>
        </Col>
        <Col>
          <Button onClick={moveToEditPage} size="small">
            수정
          </Button>
        </Col>
      </Row>
      <Descriptions bordered column={2} size="small">
        <Descriptions.Item label="공사명">{project.name}</Descriptions.Item>
        <Descriptions.Item label="위치">
          {project.location}{' '}
          {project.detailedLocation ? project.detailedLocation : ''}
        </Descriptions.Item>
        <Descriptions.Item label="발주처">{project.owner}</Descriptions.Item>
        {/* <Descriptions.Item label="설계사무소">
          {project.architect}
        </Descriptions.Item> */}
        <Descriptions.Item label="상태">
          {projectStatusKorean[project.status]}
        </Descriptions.Item>
        <Descriptions.Item label="공사기간">
          {project.startDate} ~ {project.endDate}
        </Descriptions.Item>
        <Descriptions.Item label="종류">{project.type}</Descriptions.Item>
        <Descriptions.Item label="면적(m²)">{project.area}</Descriptions.Item>
        <Descriptions.Item label="설명" style={{ whiteSpace: 'pre-wrap' }}>
          {project.description}
        </Descriptions.Item>
      </Descriptions>
      {coords === null && (
        <div style={{ marginTop: '30px' }}>
          <Row>
            <Col>
              <h3>현장 위치</h3>
            </Col>
          </Row>
          <Row justify={'center'} style={{ marginTop: '50px' }}>
            <Col>
              <Text>위치정보를 불러올 수 없습니다</Text>
            </Col>
          </Row>
        </div>
      )}

      {coords && (
        <div style={{ marginTop: '30px' }}>
          <Map center={coords} style={{ width: '100%', height: '360px' }}>
            <MapMarker position={coords}>
              {/* <div style={{ color: '#000' }}>현장 위치</div> */}
            </MapMarker>
          </Map>
        </div>
      )}
    </StyledDiv>
  );
}

export default ProjectOverviewComponent;
